module.exports = __webpack_public_path__ + "img/03_Store_1Persona.8f820ba7.jpg";